import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';
import { useHandlers } from '../../../../../context/page-context';
import type { TeamMemberApiResponse } from '../../../types';
import { useSwapOwner } from '../../hooks/use-swap-owner';

export function SwapOwnerModal({
  member,
  isOpen,
  closeModal,
}: {
  member: TeamMemberApiResponse | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const { mutate: swapOwner, isPending, reset } = useSwapOwner();

  const handleClose = () => {
    reset();
    closeModal();
  };

  const handleSubmit = () => {
    if (!member) {
      return;
    }

    swapOwner(member.id, {
      onSuccess: handleClose,
      onError: () => notificationHandler.error(),
    });
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleSubmit}
      loading={isPending}
      title={t('features:account.components.modals.swap_owner_modal.header', {
        name: member?.name ?? '',
      })}
      confirmText={t('buttons:continue')}
      message={t('features:account.components.modals.swap_owner_modal.body', {
        name: member?.name ?? '',
      })}
    />
  );
}
